<template>
  <div class="c-layer-settings">
    <component :is="`${layerType}-settings`" :id="settingsId" />
    <settings-close-button @close="closeSettings" />
  </div>
</template>

<script>
import LinksSettings from "./types/links-settings";
import NodesSettings from "./types/nodes-settings";
import ZonesSettings from "./types/zones-settings";
import EventsSettings from "./types/events-settings";
import SettingsCloseButton from "../settings-header/settings-close";

export default {
  components: {
    LinksSettings,
    NodesSettings,
    ZonesSettings,
    EventsSettings,
    SettingsCloseButton
  },
  computed: {
    settingsId() {
      return this.$store.state.calculations.settingsId;
    },
    layerType() {
      const { model } = this.$store.state.calculations;
      const layer = model.children.find(l => l.id === this.settingsId);

      return layer ? layer.datatype : null;
    }
  },
  methods: {
    closeSettings() {
      this.$store.commit("SET_CALC_FIELD", {
        field: "settingsId",
        value: null
      });
    }
  }
};
</script>

<style lang="scss">
.c-layer-settings {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
